export default "__VITE_ASSET__Gw6M_JZQ__"